import { Action } from 'redux/action';
import { createAction } from 'redux/actions/creator';
import { UsersActions } from 'redux/reducers/usersReducer';

export const closeTaskModal = (): Action<UsersActions> => {
  return createAction(UsersActions.closeTaskModal);
};
